
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.564 3.316A1.31 1.31 0 0019.688 3H18v9h1.688A1.31 1.31 0 0021 10.923V4.077a1.31 1.31 0 00-.436-.761zM16 12.788l-3.608 8.117A2 2 0 0111 19v-4a1 1 0 00-1-1H4.329a1.001 1.001 0 01-1-1.15l1.38-9a1 1 0 011-.85H16v9.788zM19.662 1a3.31 3.31 0 013.329 2.866c.006.044.009.09.009.134v7c0 .045-.003.09-.009.134A3.31 3.31 0 0119.662 14H17.65l-3.736 8.406A1 1 0 0113 23a4 4 0 01-4-4v-3H4.345a3 3 0 01-2.994-3.45l1.38-9A3.002 3.002 0 015.725 1h13.937z","fill":"#04080E"}})])
          )
        }
      }
    